export default __webpack_public_path__ + "static/Fellix-Bold-c81ab7ab8b05bcac58913fc4a85cae48.woff";